import { FeedItem } from '@knocklabs/client';

export type NotificationItemAvatar = {
  name: string;
  src: string | null;
};

/**
 * Picks the first actor with a display name for the feed cell avatar.
 */
export function getNotificationItemAvatar(item: FeedItem): NotificationItemAvatar | null {
  const actor = item.actors?.[0];
  if (!actor || !('name' in actor) || typeof actor.name !== 'string' || !actor.name.trim()) {
    return null;
  }

  return {
    name: actor.name.trim(),
    src: typeof actor.avatar === 'string' && actor.avatar ? actor.avatar : null,
  };
}
